module.exports = __webpack_public_path__ + "static/institutionLogoCentralFlorida-8f243dfc656658c51f0dca3936d07de7.png";